import type { ProbeVoice } from "@amoreg/contracts";
import { AudioLinesIcon } from "lucide-react";

import { PROBE_VOICE_LABELS, probeVoiceOptions } from "../../regulation/probe/probeVoices";
import { Button } from "../../ui/button";
import {
  Menu,
  MenuGroup,
  MenuGroupLabel,
  MenuPopup,
  MenuRadioGroup,
  MenuRadioItem,
  MenuTrigger,
} from "../../ui/menu";

/**
 * The examiner's voice, among GPT-Live's English voices. A session's voice
 * is fixed when it starts, so the picker lives beside Start, not in the
 * call: an icon that opens the voices.
 */
export function ProbeVoicePicker({
  voice,
  onChange,
  disabled = false,
}: {
  readonly voice: ProbeVoice;
  readonly onChange: (voice: ProbeVoice) => void;
  readonly disabled?: boolean;
}) {
  const label = `Voice: ${PROBE_VOICE_LABELS[voice].name}`;
  return (
    <Menu modal={false}>
      <MenuTrigger
        disabled={disabled}
        aria-label={label}
        title={label}
        render={
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            className="cursor-pointer text-muted-foreground"
          />
        }
        data-probe-voice=""
      >
        <AudioLinesIcon />
      </MenuTrigger>
      <MenuPopup align="center" className="w-60">
        <MenuGroup>
          <MenuGroupLabel>Voice</MenuGroupLabel>
          <MenuRadioGroup value={voice} onValueChange={(value) => onChange(value as ProbeVoice)}>
            {probeVoiceOptions.map((option) => (
              <MenuRadioItem key={option.value} value={option.value} closeOnClick>
                <span className="flex flex-col">
                  <span>{option.name}</span>
                  <span className="text-xs text-muted-foreground">{option.description}</span>
                </span>
              </MenuRadioItem>
            ))}
          </MenuRadioGroup>
        </MenuGroup>
      </MenuPopup>
    </Menu>
  );
}
